module.exports = __webpack_public_path__ + "static/img/knee_banner.e7f5173.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/knee_banner.svg
// module id = 4k4+
// module chunks = 7